import { FormControlLabel, FormHelperText } from '@mui/material';
import { Field, FieldAttributes, useFormikContext } from 'formik';
import { Checkbox } from 'formik-mui';
import React, { useCallback } from 'react';

import { HelpTooltip } from 'components';

type Props = FieldAttributes<any>;

export const FormikCheckbox: React.FC<Props> = ({
  name,
  label,
  tooltip,
  helperText,
  sx,
  ...rest
}) => {
  const formik = useFormikContext();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      // Without an explicit `value` prop the checkbox is a single boolean field. Formik's
      // native checkbox handling turns an undefined initial value (e.g. a missing
      // credentials key) into ["on"]/[] instead of a boolean, so set the boolean directly.
      if (rest.value === undefined) {
        formik.setFieldValue(name, e.target.checked);
      } else {
        formik.handleChange(e);
      }
      rest.onChange?.(e.target.checked);
    },
    [formik, name, rest],
  );

  return (
    <div>
      <FormControlLabel
        control={
          <Field
            component={Checkbox}
            type="checkbox"
            name={name}
            sx={{ paddingTop: 1, paddingBottom: 1 }}
            {...rest}
            onChange={handleChange}
          />
        }
        label={label}
        sx={sx}
      />
      {!!tooltip && <HelpTooltip title={tooltip} />}
      {!!helperText && (
        <FormHelperText className="!tw-ml-8 !tw-mt-0 !tw-mb-2">
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};
